import { VIEW_MANAGEMENT } from 'store/types';

function showPreloader() {
  return {
    type: VIEW_MANAGEMENT.SHOW_PRELOADER,
  };
}

export default showPreloader;
